// extracted by mini-css-extract-plugin
module.exports = {"center":"DefaultPage_center_J1c9K"};